import { useEffect, useLayoutEffect } from 'react';
import { useConfigContext } from './context/ConfigContext';
import track, { overwriteAppName } from 'c9-tracking';
import './App.scss';
import AppRouter from './router/AppRouter';
import { useStateValue } from './hooks/UseStateValue';
import { SET_SELECTION, SET_MODEL } from './store/ActionKeys';
import { FlowBlockedModal } from './pages/modals/FlowBlockedModal';
import { isCMSPreviewMode } from './helpers/isCMSPreviewMode';

function App() {
    const [, dispatch] = useStateValue();
    const config = useConfigContext();
    overwriteAppName(config.appName);

    useEffect(() => {
        // Track how many times your app is being rendered
        track.ready(true);
    }, [dispatch, config]);

    // Load cache
    useLayoutEffect(() => {
        const isFirstPage = `${config.appBasePath}/` === window.location.pathname;

        // Remove existing sessions to prevent ambiguity issues with vin-partner and number plate/maker-model
        if (isFirstPage) {
            sessionStorage.removeItem('selection');
            sessionStorage.removeItem('model');
        } else {
            const selectionCache = sessionStorage.getItem('selection');
            if (selectionCache) {
                dispatch({
                    type: SET_SELECTION,
                    payload: JSON.parse(selectionCache)
                });
            }

            const modelCache = sessionStorage.getItem('model');
            if (modelCache) {
                dispatch({
                    type: SET_MODEL,
                    payload: JSON.parse(modelCache)
                });
            }
        }
    }, [config.appBasePath, dispatch]);

    return !isCMSPreviewMode() ? (
        <>
            <AppRouter />
            <FlowBlockedModal />
        </>
    ) : (
        <>Preview</>
    );
}

export default App;
